export interface BinPeopleCounter {
  bin_people_counter_id: number;
  bin_id: number;
  bin_people_counter: number;
  is_reset: 0 | 1;
  created_date: string;
  created_by: number;
  updated_date: string;
  updated_by: number;
  bin_full_name: string;
}

export interface PeopleCounterState {
  binPeopleCounterList: BinPeopleCounter[];
  targetBinPeopleCounter: BinPeopleCounter;
}

export const initPeopleCounterState: PeopleCounterState = {
  binPeopleCounterList: [],
  targetBinPeopleCounter: {
    bin_people_counter_id: 0,
    bin_id: 0,
    bin_people_counter: 0,
    is_reset: 0,
    created_date: '',
    created_by: 0,
    updated_date: '',
    updated_by: 0,
    bin_full_name: ''
  }
};
